/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UpdateSettingsForBp$Params {
  type: string;
  bpGuid: string;
      body: string
}

export function updateSettingsForBp(http: HttpClient, rootUrl: string, params: UpdateSettingsForBp$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateSettingsForBp.PATH, 'put');
  if (params) {
    rb.path('type', params.type, {});
    rb.path('bpGuid', params.bpGuid, {});
    rb.body(params.body, 'text/plain');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateSettingsForBp.PATH = '/settings/{type}/bp/{bpGuid}';
